import React from "react";

interface MetricCardProps {
  title: string;
  value: string;
  change?: string;
  changeType?: "positive" | "negative" | "neutral";
  subtitle?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  changeType = "neutral",
  subtitle,
}) => {
  const changeColor =
    changeType === "positive"
      ? "#10b981"
      : changeType === "negative"
      ? "#ef4444"
      : "#888";

  return (
    <div
      style={{
        padding: "1.5rem",
        borderRadius: "0.5rem",
        border: "1px solid #e5e7eb",
        backgroundColor: "#fff",
      }}
    >
      <h3
        style={{ fontSize: "0.875rem", color: "#888", marginBottom: "0.5rem" }}
      >
        {title}
      </h3>
      <div
        style={{
          fontSize: "1.875rem",
          fontWeight: "bold",
          marginBottom: "0.25rem",
        }}
      >
        {value}
      </div>
      {change && (
        <p
          style={{
            fontSize: "0.75rem",
            color: changeColor,
            marginBottom: "0.25rem",
          }}
        >
          {change}
        </p>
      )}
      {subtitle && (
        <p style={{ fontSize: "0.75rem", color: "#888" }}>{subtitle}</p>
      )}
    </div>
  );
};

export default MetricCard;
